import React, {useEffect, useState} from "react";

import Step from "./Step";
import StepOneForm from "./StepOneForm";
import StepTwoForm from "./StepTwoForm";
import StepThreeForm from "./StepThreeForm";
import {useForm} from "react-hook-form";
import api from "../api";
import ResultBlock from "./ResultBlock";

const MultiStepForm = ({mode}) => {
    const {
        handleSubmit,
        register,
        setValue,
        control,
        formState: {errors, isValid},
    } = useForm({mode: "onChange"});
    const [step, setStep] = useState(1);

    const [routineCareRange, setRoutineCareRange] = useState([1, 2]);
    const [routineCareValue, setRoutineCareValue] = useState(1);
    const [hospitalizationRange, setHospitalizationRange] = useState([1, 2]);
    const [hospitalizationValue, setHospitalizationValue] = useState(1);
    const [dentaryRange, setDentaryRange] = useState([1, 2]);
    const [dentaryValue, setDentaryValue] = useState(1);
    const [opticalRange, setOpticalRange] = useState([1, 2]);
    const [opticalValue, setOpticalValue] = useState(1);
    const [employeeNumber, setEmployeeNumber] = useState("");
    const [executiveNumber, setExecutiveNumber] = useState("");
    const [notExecutiveNumber, setNotExecutiveNumber] = useState("");
    const [apeCode, setApeCode] = useState("");
    const [cities, setCities] = useState([]);
    const [city, setCity] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [apeCodes, setApeCodes] = useState([]);
    const [conventions, setConventions] = useState([]);
    const [tarif, setTarif] = useState({});
    const [selectedApeOption, setSelectedApeOption] = useState(null);
    const [devisType, setDevisType] = useState("");
    const [resultCode, setResultCode] = useState(null);
    const [tarificationChoice, setTarificationChoice] = useState("tarificationChoice1");
    const [loading, setLoading] = useState(false);

    //Gère l'écart maximum qu'il peut y avoir entre les différents sliders range
    const handleRangeNeedsChange = (changes) => {
        handleRangeNeedChange(changes[0], routineCareRange, setRoutineCareRange);
        handleRangeNeedChange(changes[0], hospitalizationRange, setHospitalizationRange);
        handleRangeNeedChange(changes[0], dentaryRange, setDentaryRange);
        handleRangeNeedChange(changes[0], opticalRange, setOpticalRange);
    };


    const handleRangeNeedChange = (min, range, setRange) => {
        if (min - range[0] > 3) {
            setRange([range[0] + 1, range[1] + 1]);
        } else if (range[0] - min > 3) {
            setRange([range[0] - 1, range[1] - 1]);
        }
    };

    //Gère l'écart maximum qu'il peut y avoir entre les différents sliders simples
    const handleNeedsChange = (change) => {
        handleNeedChange(change, routineCareValue, setRoutineCareValue);
        handleNeedChange(change, hospitalizationValue, setHospitalizationValue);
        handleNeedChange(change, dentaryValue, setDentaryValue);
        handleNeedChange(change, opticalValue, setOpticalValue);
    };

    useEffect(() => {
        if (step === 2) {
            //On recalcule les tarifs immédiatement à l'étape 2
            handleSubmit(onSubmit)();
        }
    }, [routineCareValue, hospitalizationValue, dentaryValue, opticalValue, routineCareRange, hospitalizationRange, dentaryRange, opticalRange]);

    const handleNeedChange = (change, value, setValue) => {
        if (change - value > 3) {
            setValue(value + 1);
        } else if (value - change > 3) {
            setValue(value - 1);
        }
    };

    const nextStep = () => {
        if (step === 1) {
            handleSubmit(onSubmit)();
        }

        if (isValid) {
            setStep((prevStep) => prevStep + 1)
        }
    };
    const prevStep = () => setStep((prevStep) => prevStep - 1);

    const onSubmit = async (data) => {

        try {
            const formData = new FormData();
            formData.append("optionalLevel", mode === 2);
            formData.append("routineCareRange", routineCareRange);
            formData.append("hospitalizationRange", hospitalizationRange);
            formData.append("dentaryRange", dentaryRange);
            formData.append("opticalRange", opticalRange);
            formData.append("routineCareValue", routineCareValue);
            formData.append("hospitalizationValue", hospitalizationValue);
            formData.append("dentaryValue", dentaryValue);
            formData.append("opticalValue", opticalValue);
            formData.append("inputCity", data.inputCity);
            formData.append("inputConvention", data.inputConvention);
            formData.append("inputDevisType", data.inputDevisType);
            formData.append("inputEmployeeNumber", data.inputEmployeeNumber);
            formData.append("inputExecutiveAverageAge", data.inputExecutiveAverageAge);
            formData.append("inputExecutiveNumber", data.inputExecutiveNumber);
            formData.append("inputNonExecutiveAverageAge", data.inputNonExecutiveAverageAge);
            formData.append("inputNonExecutiveNumber", notExecutiveNumber);
            formData.append("inputPostalCode", data.inputPostalCode);
            formData.append("whishedAccessionDate", data.whishedAccessionDate);
            formData.append("affiliationScheme", data.affiliationScheme);
            formData.append("healthAdditionalContract", data.healthAdditionalContract);
            formData.append("apeCode", selectedApeOption.value);
            formData.append("tarificationChoice", tarificationChoice);

            setCity(data.inputCity.split(',')[1]);

            if (step === 3) {
                formData.append("inputCompanyName", data.inputCompanyName);
                formData.append("inputCompanySiret", data.inputCompanySiret);
                formData.append("inputCompanyAddress", data.inputCompanyAddress);
                formData.append("inputEstimatePostalCode", data.inputEstimatePostalCode);
                formData.append("inputEstimateCity", data.inputEstimateCity);
                formData.append("inputCivility", data.inputCivility);
                formData.append("inputEstimateLastName", data.inputEstimateLastName);
                formData.append("inputEstimateFirstname", data.inputEstimateFirstname);
                formData.append("inputEstimateProfession", data.inputEstimateProfession);
                formData.append("inputEstimateEmail", data.inputEstimateEmail);
                formData.append("inputEstimatePhoneNumber", data.inputEstimatePhoneNumber);
            }

            // for (var pair of formData.entries()) {
            //     console.log(pair[0]+ ', ' + pair[1]);
            // }

            if (step < 3) {
                let result = await api.postPrices(formData);
                //console.log(result);
                setTarif(result);
            } else {
                setLoading(true);
                let result = await api.postEstimate(formData);
                //console.log(result);
                setLoading(false);
                setResultCode(result);
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="tw-w-full">
            <div
                className="tw-max-w-[1088px] tw-flex tw-flex-col md:tw-flex-row tw-gap-6 tw-justify-between tw-bg-white tw-mx-auto tw-p-6">
                <div className="tw-flex tw-flex-col tw-justify-center tw-gap-6 tw-w-full">
                    <span id="devis-sante-title"
                        className="tw-self-stretch tw-text-mutelios-blue tw-text-sm-h1 lg:tw-text-h1">Devis santé</span>
                    {!resultCode && <>
                        <div
                            className="tw-flex tw-items-start tw-content-start tw-gap-4 tw-self-stretch tw-flex-wrap tw-w-[312px] sm:tw-w-auto">
                            <Step title="Besoin" step={1} currentStep={step}/>
                            <Step title="Offres" step={2} currentStep={step}/>
                            <Step title="Coordonnées" step={3} currentStep={step}/>
                        </div>
                        <form className="tw-flex tw-flex-col tw-gap-6" onSubmit={handleSubmit(onSubmit)}>
                            {step === 1 && (
                                <StepOneForm
                                    routineCareRange={routineCareRange}
                                    setRoutineCareRange={setRoutineCareRange}
                                    hospitalizationRange={hospitalizationRange}
                                    setHospitalizationRange={setHospitalizationRange}
                                    dentaryRange={dentaryRange}
                                    setDentaryRange={setDentaryRange}
                                    opticalRange={opticalRange}
                                    setOpticalRange={setOpticalRange}
                                    routineCareValue={routineCareValue}
                                    setRoutineCareValue={setRoutineCareValue}
                                    hospitalizationValue={hospitalizationValue}
                                    setHospitalizationValue={setHospitalizationValue}
                                    dentaryValue={dentaryValue}
                                    setDentaryValue={setDentaryValue}
                                    opticalValue={opticalValue}
                                    setOpticalValue={setOpticalValue}
                                    handleRangeNeedsChange={handleRangeNeedsChange}
                                    handleNeedsChange={handleNeedsChange}
                                    mode={mode}
                                    register={register}
                                    apeCode={apeCode}
                                    apeCodes={apeCodes}
                                    setApeCode={setApeCode}
                                    setApeCodes={setApeCodes}
                                    employeeNumber={employeeNumber}
                                    setEmployeeNumber={setEmployeeNumber}
                                    executiveNumber={executiveNumber}
                                    setExecutiveNumber={setExecutiveNumber}
                                    notExecutiveNumber={notExecutiveNumber}
                                    setNotExecutiveNumber={setNotExecutiveNumber}
                                    cities={cities}
                                    setCities={setCities}
                                    postalCode={postalCode}
                                    setPostalCode={setPostalCode}
                                    conventions={conventions}
                                    setConventions={setConventions}
                                    selectedApeOption={selectedApeOption}
                                    setSelectedApeOption={setSelectedApeOption}
                                    errors={errors}
                                    setValue={setValue}
                                    control={control}
                                    setDevisType={setDevisType}
                                />
                            )}
                            {step === 2 && (
                                <StepTwoForm
                                    routineCareRange={routineCareRange}
                                    setRoutineCareRange={setRoutineCareRange}
                                    hospitalizationRange={hospitalizationRange}
                                    setHospitalizationRange={setHospitalizationRange}
                                    dentaryRange={dentaryRange}
                                    setDentaryRange={setDentaryRange}
                                    opticalRange={opticalRange}
                                    setOpticalRange={setOpticalRange}
                                    routineCareValue={routineCareValue}
                                    setRoutineCareValue={setRoutineCareValue}
                                    hospitalizationValue={hospitalizationValue}
                                    setHospitalizationValue={setHospitalizationValue}
                                    dentaryValue={dentaryValue}
                                    setDentaryValue={setDentaryValue}
                                    opticalValue={opticalValue}
                                    setOpticalValue={setOpticalValue}
                                    handleRangeNeedsChange={handleRangeNeedsChange}
                                    handleNeedsChange={handleNeedsChange}
                                    register={register}
                                    tarif={tarif}
                                    mode={mode}
                                    devisType={devisType}
                                    tarificationChoice={tarificationChoice}
                                    setTarificationChoice={setTarificationChoice}
                                />
                            )}
                            {step === 3 && (
                                <StepThreeForm
                                    register={register}
                                    errors={errors}
                                    city={city}
                                    postalCode={postalCode}
                                />
                            )}
                            {step === 1 && (
                                <div
                                    className="tw-flex tw-w-[342px] tw-self-center tw-flex-col tw-gap-2 tw-items-start">
                                    <button type="button" onClick={nextStep}
                                            className="btn btn-secondary tw-self-stretch">Recevoir un devis
                                    </button>
                                </div>
                            )}
                            {step === 2 && (
                                <>
                                    <div
                                        className="tw-flex tw-flex-col-reverse tw-gap-3 tw-self-stretch md:tw-flex-row md:tw-gap-2">
                                        <button onClick={prevStep}
                                                className="tw-flex-1 tw-text-center btn btn-link-secondary tw-self-stretch">Modifier
                                            ma
                                            demande
                                        </button>
                                        <a href="/contact?tab=entreprises" className="tw-flex-1 btn btn-primary tw-self-stretch">Parler à un
                                            conseiller
                                        </a>
                                        <button onClick={nextStep}
                                                className="tw-flex-1 btn btn-secondary tw-self-stretch">Recevoir mon
                                            devis
                                        </button>
                                    </div>
                                </>
                            )}
                            {step === 3 && (
                                <div
                                    className="tw-flex tw-w-[342px] tw-self-center sm:tw-self-end tw-flex-col tw-gap-2 tw-items-start">
                                    <button disabled={loading} type="submit" className="btn btn-secondary tw-self-stretch">
                                        {loading ? 'Génération du devis en cours...' : 'Recevoir mon devis'}
                                    </button>
                                </div>
                            )}
                        </form>
                    </>}
                    {resultCode && <ResultBlock resultCode={resultCode}/>}
                </div>
                <div
                    className={`${step === 1 ? "" : "tw-hidden"} tw-flex tw-shrink-0 tw-flex-col tw-gap-4 tw-self-stretch tw-w-[342px] tw-px-[64px] tw-py-[24px]`}>
                    <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-self-stretch tw-gap-2">
                        <div
                            className="tw-w-[88px] tw-h-[88px] tw-rounded-full tw-bg-mutelios-orange tw-flex tw-items-center tw-justify-center">
                            <img width="56" height="56" src="/o/mutelios-theme-css/icons/ChatsCircle.svg" alt=""/>
                        </div>
                        <span className="tw-text-mutelios-orange tw-text-h3 tw-text-center">Un conseiller Entreprises Mutélios vous rappelle gratuitement</span>
                        <span className="tw-text-mutelios-txt-color tw-text-body tw-text-center">Le jour et l’heure de votre choix</span>
                        <div className="tw-flex tw-self-stretch tw-flex-col  tw-items-start">
                            <a className="btn btn-primary tw-self-stretch" href="/contact?tab=entreprises">
                                Être rappelé
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MultiStepForm;
